import axios from 'axios';
import config from '../config';
import { kilometersToMeters } from './converter';

const evURL = config.evProfiles.url;

const getAuthHeaders = (oAuth, apiKey) => {
  if (apiKey) {
    return {};
  }
  if (oAuth?.accessToken) {
    return {
      headers: {
        Authorization: `Bearer ${oAuth.accessToken}`,
      },
    };
  }
  return {};
};

export const fetchEVMakes = async (oAuth, apiKey) => {
  try {
    const url = apiKey ? `${evURL}/makes?apiKey=${apiKey}` : `${evURL}/makes`;
    const response = await axios.get(url, getAuthHeaders(oAuth, apiKey));
    return response.data?.items || [];
  } catch (error) {
    console.error('Error fetching EV makes:', error);
    return [];
  }
};

export const fetchEVModels = async (makeId, oAuth, apiKey) => {
  try {
    const url = apiKey
      ? `${evURL}/makes/${makeId}/models?apiKey=${apiKey}`
      : `${evURL}/makes/${makeId}/models`;
    const response = await axios.get(url, getAuthHeaders(oAuth, apiKey));
    return response.data?.items || [];
  } catch (error) {
    console.error(`Error fetching models for ${makeId}:`, error);
    return [];
  }
};

export const fetchEVVariants = async (makeId, modelId, oAuth, apiKey) => {
  try {
    const url = apiKey
      ? `${evURL}/makes/${makeId}/models/${modelId}/variants?apiKey=${apiKey}`
      : `${evURL}/makes/${makeId}/models/${modelId}/variants`;
    const response = await axios.get(url, getAuthHeaders(oAuth, apiKey));
    return response.data?.items || [];
  } catch (error) {
    console.error(`Error fetching variants for ${makeId}/${modelId}:`, error);
    return [];
  }
};

export const calculateMaxDistance = (rangeKm, safetyBufferPercent = 20) => {
  if (!rangeKm || rangeKm <= 0) return 0;

  const rangeMeters = kilometersToMeters(rangeKm);
  const safetyFactor = 1 - safetyBufferPercent / 100;

  return Math.round(rangeMeters * safetyFactor);
};

export const getEVProfileName = (make, model, variant) => {
  if (!make && !model && !variant) return 'EV';
  return [make, model, variant].filter(Boolean).join(' ');
};
